import styled from 'styled-components';

import { Link } from '@sorare/routing';

import { Horizontal, Vertical } from '#src/atoms/layout/flex/index.tsx';
import { BodyM, LabelS } from '#src/atoms/typography/index.tsx';
import { proxyUrl } from '#src/atoms/ui/ResponsiveImg/index.tsx';

const LogoContainer = styled.div`
  width: var(--triple-unit);
  text-align: center;
`;
const Logo = styled.img`
  width: 100%;
`;

export type Props = {
  club: {
    slug: string;
    name: string;
    pictureUrl: string | null;
    to: string;
    competition?: {
      name: string;
      to: string;
    };
  };
};

export const RelatedClub = ({ club }: Props) => {
  return (
    <Horizontal>
      <LogoContainer>
        {!!club.pictureUrl && (
          <Logo
            src={proxyUrl(club.pictureUrl, { cropWidth: 80 })}
            alt={club.name}
          />
        )}
      </LogoContainer>
      <Vertical gap={0}>
        <BodyM as="p">
          <Link to={club.to}>{club.name}</Link>
        </BodyM>
        {!!club.competition && (
          <Link to={club.competition.to}>
            <LabelS as="p" color="var(--c-nd-600)">
              {club.competition.name}
            </LabelS>
          </Link>
        )}
      </Vertical>
    </Horizontal>
  );
};
